// extracted by mini-css-extract-plugin
export default {"header":"HF","container":"IF","accordeonitem":"JF","itemsticky":"KF","itemopen":"LF","open":"MF","productname":"NF","productinfo":"OF","flavorstext":"PF","invalidlimit":"QF","limit":"RF","scrollUpAccordion":"SF","wrapper":"TF"};
    if(module.hot) {
      // 1726593106362
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  